<template>
    <div class="table-page" v-if="loaded">
        <my-table ref="table" :name="pageKey" :cols="cols" :data="list" :loading="loading" :page-param="page"
                  :batch="batch" :operate="operate"
                  @sort="sort"
                  @init="init" @refresh="getList" @pageChange="pageChange" @paramChange="paramChange" @cndClusterChange="cndClusterChange">
            <template #right>
                <el-button class="btn-blue" plain icon="el-icon-plus" @click="add" :disabled="'M_SM_RO_I'|auth">添加</el-button>
                <el-button class="btn-blue" plain icon="el-icon-menu" @click="authorize" :disabled="'M_SM_RO_AU'|auth">菜单授权</el-button>
                <el-button class="btn-blue" plain icon="el-icon-user" @click="userShow">用户</el-button>
            </template>

        </my-table>

·        <common-add ref="add" :dialog="editDialog" :cols="cols" @save="editSave" @delEdit="delEdit"></common-add>
        <common-detail :dialog="detailDialog" :cols="cols" @save="editSave"></common-detail>

        <!--授权弹窗-->
        <my-drawer class="admin-role" :show.sync="tree.show" :loading="tree.loading" title="授权"
                         width="400px">
            <div class="admin-role__tree-opera">
                <i class="el-icon-plus" @click="openOrClose(true)"></i>
                <i class="el-icon-minus" @click="openOrClose()" style="float:right"></i>
            </div>
            <el-tree ref="tree" :data="tree.rightList" :default-checked-keys="tree.defaultCheckedKeys" v-loading="tree.loading"
                     show-checkbox node-key="id" :props="tree.defaultProps" default-expand-all highlight-current></el-tree>
            <div class="btns">
                <el-button class="btn-solid-blue" icon="el-icon-success" :loading="tree.loading" @click="authorizeSave">保存</el-button>
                <el-button icon="el-icon-error" @click="tree.show = false">取消</el-button>
            </div>
        </my-drawer>

        <!--用户弹窗-->
        <my-dialog :show.sync="user.show" :loading="user.loading" :title="`${current.roleName} - 分配用户`"
                         @save="userSave" width="1000px">
          <el-row type="flex" justify="center" align="middle" class="transfer small-table">
            <el-col :span="11">
              <ls-admin-table ref="leftTable" :columns="user.left.columns" :data="user.left.list" :pageParam="user.left.query"
                              pageLayout="total, sizes, prev, pager, next" :loading="user.left.loading"
                              @handleSizeChange="handleLeftSizeChange"
                              @handleCurrentChange="handleLeftCurrentChange"
                              style="height: 500px;"></ls-admin-table>
            </el-col>
            <el-col :span="2" style="text-align:center">
              <i class="el-icon-arrow-right ls-middle-arrow" @click="transfer"></i>
            </el-col>
            <el-col :span="11" style="position:relative;align-self:flex-start">
              <ls-admin-table :columns="user.right.columns" :data="user.right.list" hide-multiple hide-page
                              style="height: 500px;">
                <template v-slot:slot_operate="data">
                  <el-button type="text" size="mini" @click="removeObj(data.$index,user)">移除</el-button>
                </template>
              </ls-admin-table>
            </el-col>
          </el-row>
        </my-dialog>

         <!--主体弹窗-->
        <my-dialog :show.sync="manageSubject.show" :loading="manageSubject.loading" :title="`${current.roleName} - 分配主体`"
                         @save="manageSubjectSave" width="1000px">
          <el-row type="flex" justify="center" align="middle" class="transfer small-table">
            <el-col :span="11">
              <ls-admin-table ref="leftTable" :columns="manageSubject.left.columns" :data="manageSubject.left.list" :pageParam="manageSubject.left.query"
                              pageLayout="prev, pager, next" :loading="manageSubject.left.loading"
                              @handleSizeChange="handleLeftSizeChangeManageSubject"
                              @handleCurrentChange="handleLeftCurrentChangeManageSubject"
                              style="height: 500px;"></ls-admin-table>
            </el-col>
            <el-col :span="2" style="text-align:center">
              <i class="el-icon-arrow-right ls-middle-arrow" @click="transferManageSubject"></i>
            </el-col>
            <el-col :span="11" style="position:relative;align-self:flex-start">
              <ls-admin-table :columns="manageSubject.right.columns" :data="manageSubject.right.list" hide-multiple hide-page
                              style="height: 500px;">
                <template v-slot:slot_operate="data">
                  <el-button type="text" size="mini" @click="removeObj(data.$index,manageSubject)">移除</el-button>
                </template>
              </ls-admin-table>
            </el-col>
          </el-row>
        </my-dialog>


         <!--部门弹窗-->
        <my-dialog :show.sync="department.show" :loading="department.loading" :title="`${current.roleName} - 分配部门`"
                         @save="departmentSave" width="1000px">
          <el-row type="flex" justify="center" align="middle" class="transfer small-table">
            <el-col :span="11">
              <ls-admin-table ref="leftTable" :columns="department.left.columns" :data="department.left.list" :pageParam="department.left.query"
                              pageLayout="prev, pager, next" :loading="department.left.loading"
                              @handleSizeChange="handleLeftSizeChangeDepartment"
                              @handleCurrentChange="handleLeftCurrentDepartment"
                              style="height: 500px;"></ls-admin-table>
            </el-col>
            <el-col :span="2" style="text-align:center">
              <i class="el-icon-arrow-right ls-middle-arrow" @click="transferDepartment"></i>
            </el-col>
            <el-col :span="11" style="position:relative;align-self:flex-start">
              <ls-admin-table :columns="department.right.columns" :data="department.right.list" hide-multiple hide-page
                              style="height: 500px;">
                <template v-slot:slot_operate="data">
                  <el-button type="text" size="mini" @click="removeObj(data.$index,department)">移除</el-button>
                </template>
              </ls-admin-table>
            </el-col>
          </el-row>
        </my-dialog>


        <!--地区弹窗-->
        <my-dialog :show.sync="area.show" :loading="area.loading" :title="`${current.roleName} - 分配地区`"
                         @save="areaSave" width="1000px">
          <el-row type="flex" justify="center" align="middle" class="transfer small-table">
            <el-col :span="11">
              <ls-admin-table ref="leftTable" :columns="area.left.columns" :data="area.left.list" :pageParam="area.left.query"
                              pageLayout="prev, pager, next" :loading="area.left.loading"
                              @handleSizeChange="handleLeftSizeChangeArea"
                              @handleCurrentChange="handleLeftCurrentArea"
                              style="height: 500px;"></ls-admin-table>
            </el-col>
            <el-col :span="2" style="text-align:center">
              <i class="el-icon-arrow-right ls-middle-arrow" @click="transferArea"></i>
            </el-col>
            <el-col :span="11" style="position:relative;align-self:flex-start">
              <ls-admin-table :columns="area.right.columns" :data="area.right.list" hide-multiple hide-page
                              style="height: 500px;">
                <template v-slot:slot_operate="data">
                  <el-button type="text" size="mini" @click="removeObj(data.$index,area)">移除</el-button>
                </template>
              </ls-admin-table>
            </el-col>
          </el-row>
        </my-dialog>

        <!--人员弹窗-->
        <my-dialog :show.sync="person.show" :loading="person.loading" :title="`${current.roleName} - 分配人员`"
                         @save="personSave" width="1000px">
          <el-row type="flex" justify="center" align="middle" class="transfer small-table">
            <el-col :span="11">
              <ls-admin-table ref="leftTable" :columns="person.left.columns" :data="person.left.list" :pageParam="person.left.query"
                              pageLayout="prev, pager, next" :loading="person.left.loading"
                              @handleSizeChange="handleLeftSizeChangePerson"
                              @handleCurrentChange="handleLeftCurrentPerson"
                              style="height: 500px;"></ls-admin-table>
            </el-col>
            <el-col :span="2" style="text-align:center">
              <i class="el-icon-arrow-right ls-middle-arrow" @click="transferPerson"></i>
            </el-col>
            <el-col :span="11" style="position:relative;align-self:flex-start">
              <ls-admin-table :columns="person.right.columns" :data="person.right.list" hide-multiple hide-page
                              style="height: 500px;">
                <template v-slot:slot_operate="data">
                  <el-button type="text" size="mini" @click="removeObj(data.$index,person)">移除</el-button>
                </template>
              </ls-admin-table>
            </el-col>
          </el-row>
        </my-dialog>


        <!--事业部弹窗-->
        <my-dialog :show.sync="business.show" :loading="business.loading" :title="`${current.roleName} - 分配事业部`"
                         @save="businessSave" width="1000px">
          <el-row type="flex" justify="center" align="middle" class="transfer small-table">
            <el-col :span="11">
              <ls-admin-table ref="leftTable" :columns="business.left.columns" :data="business.left.list" :pageParam="business.left.query"
                              pageLayout="prev, pager, next" :loading="business.left.loading"
                              @handleSizeChange="handleLeftSizeChangeBusiness"
                              @handleCurrentChange="handleLeftCurrentBusiness"
                              style="height: 500px;"></ls-admin-table>
            </el-col>
            <el-col :span="2" style="text-align:center">
              <i class="el-icon-arrow-right ls-middle-arrow" @click="transferBusiness"></i>
            </el-col>
            <el-col :span="11" style="position:relative;align-self:flex-start">
              <ls-admin-table :columns="business.right.columns" :data="business.right.list" hide-multiple hide-page
                              style="height: 500px;">
                <template v-slot:slot_operate="data">
                  <el-button type="text" size="mini" @click="removeObj(data.$index,business)">移除</el-button>
                </template>
              </ls-admin-table>
            </el-col>
          </el-row>
        </my-dialog>

    </div>
</template>

<script>
    import myMixin from '@/util/myMixin';
    import tableMixin from '@/util/tableMixin';
    import adminHelp from '@/util/adminHelp';

    export default {
        mixins: [tableMixin, myMixin],
        data() {
            return {
                loaded:true,
                pageKey: 'role',
                api: {
                    list: 'sys/role/findRolePage',   // 列表接口
                    detail: 'sys/role/findRoleByPk', // 详情接口
                    add: 'sys/role/insertRole',      // 新增接口
                    update: 'sys/role/updateRole',   // 修改接口
                    del: 'sys/role/deleteRole',      // 删除接口
                },

                operate: [
                    {txt: '修改', auth: 'M_SM_RO_E', type: 'primary', icon: 'el-icon-edit', event: this.update},
                    {txt: '详情', auth: '', type: 'success', icon: 'el-icon-view', event: this.detail},
                    {txt: '删除', auth: 'M_SM_RO_D', type: 'danger', icon: 'el-icon-circle-close', event: this.del},
                ],

                // 批量操作的参数
                batch: [
                    {txt: '批量删除', api: 'sys/role/deleteRoleList', power:'delete',auth:'M_SM_RO_D'},
                ],
                cols: [
                    {
                        key: "roleCode",
                        value: "角色编号",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: true,        // 列表可现实
                        viewAdd: true,         // 新增可现实
                        viewEdit: true,        // 修改可现实
                        viewDetail:true,        // 详情
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 150,            // 宽度
                    },
                    {
                        key: "roleName",
                        value: "角色名称",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: true,        // 列表可现实
                        viewAdd: true,         // 新增可现实
                        viewEdit: true,        // 修改可现实
                        viewDetail:true,        // 详情
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 200,            // 宽度
                    },
                    {
                        key: "sysDefault",
                        value: "系统默认",
                        searchNormal: true,
                        searchAdvance: true,
                        viewList: true,
                        viewAdd: true,
                        viewEdit: true,
                        viewDetail:true,        // 详情
                        minWidth: 100,
                        type: this.$variable.colType.SELECT,
                        param: {
                            dict: '000004'
                        }
                    },
                    {
                        key: "remark",
                        value: "备注",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: true,        // 列表可现实
                        viewAdd: true,         // 新增可现实
                        viewEdit: true,        // 修改可现实
                        viewDetail:true,        // 详情
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 200,            // 宽度
                    },
                    {
                        key: "makeName",
                        value: "创建人",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: true,        // 列表可现实
                        viewAdd: false,         // 新增可现实
                        viewEdit: false,        // 修改可现实
                        viewDetail:true,        // 详情
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 150,            // 宽度
                    },
                    {
                        key: "makeTime",
                        value: "创建时间",
                        searchNormal: true,
                        searchAdvance: true,
                        viewList: true,
                        viewAdd: false,
                        viewEdit: false,
                        viewDetail:true,        // 详情
                        minWidth: 150,
                        type: this.$variable.colType.DATE,
                    },
                    {
                        key: "modifyName",
                        value: "修改人",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: true,        // 列表可现实
                        viewAdd: false,         // 新增可现实
                        viewEdit: false,        // 修改可现实
                        viewDetail:true,        // 详情
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 150,            // 宽度
                    },
                    {
                        key: "modifyTime",
                        value: "修改时间",
                        searchNormal: true,
                        searchAdvance: true,
                        viewList: true,
                        viewAdd: false,
                        viewEdit: false,
                        minWidth: 150,
                        type: this.$variable.colType.DATE,
                    },
                ],

                user: adminHelp.getDialog('', {
                  title: '分配用户',
                  handle: 'sys/userRole/insertRoleUsers',
                  left: {
                    loading: false,
                    list: [],
                    query: adminHelp.getPage(),
                    columns: [
                      {name: 'userCode', value: '用户账号', width: 100},
                      {name: 'userName', value: '用户名称', width: 100}
                    ],
                  },
                  right: {
                    list: [],
                    columns: [
                      {name: 'operate', value: '', width: 100},
                      {name: 'userCode', value: '用户账号', width: 100},
                      {name: 'userName', value: '用户名称', width: 100}
                    ],
                  },
                }),

                manageSubject: adminHelp.getDialog('', {
                  title: '分配主体',
                  handle: 'sys/powerData/insertRolePowerData',
                  left: {
                    loading: false,
                    list: [],
                    query: adminHelp.getPage(),
                    columns: [
                      {name: 'manageSubjectCode', value: '管理主体编码', width: 100},
                      {name: 'manageSubjectName', value: '管理主体名称', width: 100}
                    ],
                  },
                  right: {
                    list: [],
                    columns: [
                      {name: 'operate', value: '', width: 100},
                      {name: 'manageSubjectCode', value: '管理主体编码', width: 100},
                      {name: 'manageSubjectName', value: '管理主体名称', width: 100}
                    ],
                  },
                }),


                 department: adminHelp.getDialog('', {
                  title: '分配部门',
                  handle: 'sys/powerData/insertRolePowerData',
                  left: {
                    loading: false,
                    list: [],
                    query: adminHelp.getPage(),
                    columns: [
                      {name: 'deptCode', value: '部门编码', width: 100},
                      {name: 'deptName', value: '部门名称', width: 100}
                    ],
                  },
                  right: {
                    list: [],
                    columns: [
                      {name: 'operate', value: '', width: 100},
                      {name: 'deptCode', value: '部门编码', width: 100},
                      {name: 'deptName', value: '部门名称', width: 100}
                    ],
                  },
                }),

                area: adminHelp.getDialog('', {
                  title: '分配地区',
                  handle: 'sys/powerData/insertRolePowerData',
                  left: {
                    loading: false,
                    list: [],
                    query: adminHelp.getPage(),
                    columns: [
                      {name: 'areaCode', value: '地区编码', width: 100},
                      {name: 'areaName', value: '地区名称', width: 100},
                      {name: 'parentId', value: '父编码', width: 100}
                    ],
                  },
                  right: {
                    list: [],
                    columns: [
                      {name: 'operate', value: '', width: 100},
                      {name: 'areaCode', value: '地区编码', width: 100},
                      {name: 'areaName', value: '地区名称', width: 100},
                      {name: 'parentId', value: '父编码', width: 100}
                    ],
                  },
                }),

                person: adminHelp.getDialog('', {
                  title: '分配人员',
                  handle: 'sys/powerData/insertRolePowerData',
                  left: {
                    loading: false,
                    list: [],
                    query: adminHelp.getPage(),
                    columns: [
                      {name: 'personCode', value: '人员编码', width: 100},
                      {name: 'personName', value: '人员名称', width: 100}
                    ],
                  },
                  right: {
                    list: [],
                    columns: [
                      {name: 'operate', value: '', width: 100},
                      {name: 'personCode', value: '人员编码', width: 100},
                      {name: 'personName', value: '人员名称', width: 100}
                    ],
                  },
                }),


                business: adminHelp.getDialog('', {
                  title: '分配事业部',
                  handle: 'sys/powerData/insertRolePowerData',
                  left: {
                    loading: false,
                    list: [],
                    query: adminHelp.getPage(),
                    columns: [
                      {name: 'busiCode', value: '事业部编码', width: 100},
                      {name: 'busiName', value: '事业部名称', width: 100}
                    ],
                  },
                  right: {
                    list: [],
                    columns: [
                      {name: 'operate', value: '', width: 100},
                      {name: 'busiCode', value: '事业部编码', width: 100},
                      {name: 'busiName', value: '事业部名称', width: 100}
                    ],
                  },
                }),

                current: {},


                // tree
                tree: adminHelp.getDialog('授权', {
                    item: {},
                    handle: 'sys/powerMenu/insertRoleMenus',
                    defaultProps: {
                        children: 'children',
                        label: 'menuName'
                    },
                    rightList: [],
                    defaultCheckedKeys: []
                })
            }
        },
        methods: {
            handlePowerData(item){
                if(item == 0){
                    // 管理主体
                    this.manageSubjectShow();
                }else if(item == 1){
                    // 部门
                    this.departmentShow();
                }else if(item == 2){
                    // 地区
                    this.areaShow();
                }else if(item == 3){
                    // 人员
                    this.personShow();
                }else if(item == 4){
                    // 事业部
                    this.businessShow();
                }
            },

             // 用户弹窗
              userShow() {
                const select = this.$refs.table.$refs.table.selection
                if (select.length === 1) {
                  this.current = select[0]
                  adminHelp.showDialog(this.user)
                  this.loadUserLeft()
                  this.loadUserRight()
                } else {
                     this.$help.error('请先选择有效记录，再执行该操作。')
                }
              },

            userSave() {
              let arr = []
              this.user.right.list.forEach(item => {
                arr.push(item.id)
              })
                 console.log(arr)
                 this.$api.post('sys/userRole/insertRoleUsers', {
                  roleId: this.current.id,
                  userIdList: arr
              })
               .then(res => {
                     this.$help.success(res.msg)
                     this.user.show = false
                   })
               .catch(error => {
                     this.$help.error(error.error || error.obj)
                 })
               .finally(() => {
                     this.user.show = false
               })
            },

             loadUserLeft() {
              this.user.left.loading = true
              this.$api.post('sys/user/findUserPage',this.user.left.query)
                .then(res => {
                  this.user.left.list = res.records
                  this.user.left.query.total = res.total
                })
                .finally(() => {
                  this.user.left.loading = false
                })
            },
            loadUserRight() {
            this.$api.post('sys/role/selectUserByRoleId',{roleId:this.current.id})
                .then(res => {
                  this.user.right.list = res
                })
            },

             handleLeftSizeChange(val) {
                this.user.left.query.size = val
                this.user.left.query.current = 1
                this.loadUserLeft()
              },
              handleLeftCurrentChange(val) {
                if (typeof val === 'number') {
                  this.user.left.query.current = val
                  this.loadUserLeft()

                }
              },
              transfer() {
                  this.$refs.leftTable.$refs.datatable.selection.forEach(item => {
                    let flag = false
                    for (let i = 0; i < this.user.right.list.length; i += 1) {
                      if (item.id === this.user.right.list[i].id) {
                        flag = true
                      }
                    }
                    !flag && this.user.right.list.push(item)
                  })
                },


            // 主体弹窗
              manageSubjectShow() {
                const select = this.$refs.table.$refs.table.selection
                if (select.length === 1) {
                  this.current = select[0]
                  adminHelp.showDialog(this.manageSubject)
                  this.loadManageSubjectLeft()
                  this.loadManageSubjectRight()
                } else {
                     this.$help.error('请先选择有效记录，再执行该操作。')
                }
              },

            manageSubjectSave() {
              let arr = []
              this.manageSubject.right.list.forEach(item => {
                arr.push(item.manageSubjectCode)
              })
                 this.$api.post('sys/powerData/insertRolePowerData', {
                  roleId: this.current.id,
                  objectIdList: arr,
                  powerObject: 0
              })
               .then(res => {
                     this.$help.success(res.msg)
                     this.manageSubject.show = false
                   })
               .catch(error => {
                     this.$help.error(error.error || error.obj)
                 })
               .finally(() => {
                     this.manageSubject.show = false
               })
            },

             loadManageSubjectLeft() {
              this.manageSubject.left.loading = true
              this.$api.post('base/manageSubject/findManageSubjectPage',this.manageSubject.left.query)
                .then(res => {
                  this.manageSubject.left.list = res.records
                  this.manageSubject.left.query.total = res.total
                })
                .finally(() => {
                  this.manageSubject.left.loading = false
                })
            },
            loadManageSubjectRight() {
            this.$api.post('base/manageSubject/selectManageSubjectByRoleId',{roleId:this.current.id})
                .then(res => {
                  this.manageSubject.right.list = res
                })
            },

             handleLeftSizeChangeManageSubject(val) {
                this.manageSubject.left.query.size = val
                this.manageSubject.left.query.current = 1
                this.loadManageSubjectLeft()
              },
              handleLeftCurrentChangeManageSubject(val) {
                if (typeof val === 'number') {
                  this.manageSubject.left.query.current = val
                  this.loadManageSubjectLeft()

                }
              },
              transferManageSubject() {
                  this.$refs.leftTable.$refs.datatable.selection.forEach(item => {
                    let flag = false
                    for (let i = 0; i < this.manageSubject.right.list.length; i += 1) {
                      if (item.id === this.manageSubject.right.list[i].id) {
                        flag = true
                      }
                    }
                    !flag && this.manageSubject.right.list.push(item)
                  })
                },

            // 部门弹窗
              departmentShow() {
                const select = this.$refs.table.$refs.table.selection
                if (select.length === 1) {
                  this.current = select[0]
                  adminHelp.showDialog(this.department)
                  this.loadDepartmentLeft()
                  this.loadDepartmentRight()
                } else {
                     this.$help.error('请先选择有效记录，再执行该操作。')
                }
              },

            departmentSave() {
              let arr = []
              this.department.right.list.forEach(item => {
                arr.push(item.deptCode)
              })
                 this.$api.post('sys/powerData/insertRolePowerData', {
                  roleId: this.current.id,
                  objectIdList: arr,
                  powerObject: 1
              })
               .then(res => {
                     this.$help.success(res.msg)
                     this.department.show = false
                   })
               .catch(error => {
                     this.$help.error(error.error || error.obj)
                 })
               .finally(() => {
                     this.department.show = false
               })
            },

             loadDepartmentLeft() {
              this.department.left.loading = true
              this.department.left.query.model.checkStatus = 1
              this.$api.post('base/department/findDepartmentPage',this.department.left.query)
                .then(res => {
                  this.department.left.list = res.records
                  this.department.left.query.total = res.total
                })
                .finally(() => {
                  this.department.left.loading = false
                })
            },
            loadDepartmentRight() {
            this.$api.post('base/department/selectDepartmentByRoleId',{roleId:this.current.id})
                .then(res => {
                  this.department.right.list = res
                })
            },

             handleLeftSizeChangeDepartment(val) {
                this.department.left.query.size = val
                this.department.left.query.current = 1
                this.loadDepartmentLeft()
              },
              handleLeftCurrentDepartment(val) {
                if (typeof val === 'number') {
                  this.department.left.query.current = val
                  this.loadDepartmentLeft()

                }
              },
              transferDepartment() {
                  this.$refs.leftTable.$refs.datatable.selection.forEach(item => {
                    let flag = false
                    for (let i = 0; i < this.department.right.list.length; i += 1) {
                      if (item.id === this.department.right.list[i].id) {
                        flag = true
                      }
                    }
                    !flag && this.department.right.list.push(item)
                  })
                },

                // 地区弹窗
              areaShow() {
                const select = this.$refs.table.$refs.table.selection
                if (select.length === 1) {
                  this.current = select[0]
                  adminHelp.showDialog(this.area)
                  this.loadAreaLeft()
                  this.loadAreaRight()
                } else {
                     this.$help.error('请先选择有效记录，再执行该操作。')
                }
              },

            areaSave() {
              let arr = []
              this.area.right.list.forEach(item => {
                arr.push(item.areaCode)
              })
                 this.$api.post('sys/powerData/insertRolePowerData', {
                  roleId: this.current.id,
                  objectIdList: arr,
                  powerObject: 2
              })
               .then(res => {
                     this.$help.success(res.msg)
                     this.area.show = false
                   })
               .catch(error => {
                     this.$help.error(error.error || error.obj)
                 })
               .finally(() => {
                     this.area.show = false
               })
            },

             loadAreaLeft() {
              this.area.left.loading = true
              this.$api.post('sys/area/findAreaPage',this.area.left.query)
                .then(res => {
                  this.area.left.list = res.records
                  this.area.left.query.total = res.total
                })
                .finally(() => {
                  this.area.left.loading = false
                })
            },
            loadAreaRight() {
            this.$api.post('sys/area/selectAreaByRoleId',{roleId:this.current.id})
                .then(res => {
                  this.area.right.list = res
                })
            },

             handleLeftSizeChangeArea(val) {
                this.area.left.query.size = val
                this.area.left.query.current = 1
                this.loadAreaLeft()
              },
              handleLeftCurrentArea(val) {
                if (typeof val === 'number') {
                  this.area.left.query.current = val
                  this.loadAreaLeft()

                }
              },
              transferArea() {
                  this.$refs.leftTable.$refs.datatable.selection.forEach(item => {
                    let flag = false
                    for (let i = 0; i < this.area.right.list.length; i += 1) {
                      if (item.areaCode === this.area.right.list[i].areaCode) {
                        flag = true
                      }
                    }
                    !flag && this.area.right.list.push(item)
                  })
                },

                // 人员弹窗
              personShow() {
                const select = this.$refs.table.$refs.table.selection
                if (select.length === 1) {
                  this.current = select[0]
                  adminHelp.showDialog(this.person)
                  this.loadPersonLeft()
                  this.loadPersonRight()
                } else {
                     this.$help.error('请先选择有效记录，再执行该操作。')
                }
              },

            personSave() {
              let arr = []
              this.person.right.list.forEach(item => {
                arr.push(item.personCode)
              })
                 this.$api.post('sys/powerData/insertRolePowerData', {
                  roleId: this.current.id,
                  objectIdList: arr,
                  powerObject: 3
              })
               .then(res => {
                     this.$help.success(res.msg)
                     this.person.show = false
                   })
               .catch(error => {
                     this.$help.error(error.error || error.obj)
                 })
               .finally(() => {
                     this.person.show = false
               })
            },

             loadPersonLeft() {
              this.person.left.loading = true
              this.person.left.query.model.checkStatus = 1
              this.$api.post('base/person/findPersonPage',this.person.left.query)
                .then(res => {
                  this.person.left.list = res.records
                  this.person.left.query.total = res.total
                })
                .finally(() => {
                  this.person.left.loading = false
                })
            },
            loadPersonRight() {
            this.$api.post('base/person/selectPersonByRoleId',{roleId:this.current.id})
                .then(res => {
                  this.person.right.list = res
                })
            },

             handleLeftSizeChangePerson(val) {
                this.person.left.query.size = val
                this.person.left.query.current = 1
                this.loadPersonLeft()
              },
              handleLeftCurrentPerson(val) {
                if (typeof val === 'number') {
                  this.person.left.query.current = val
                  this.loadPersonLeft()

                }
              },
              transferPerson() {
                  this.$refs.leftTable.$refs.datatable.selection.forEach(item => {
                    let flag = false
                    for (let i = 0; i < this.person.right.list.length; i += 1) {
                      if (item.mainId === this.person.right.list[i].mainId) {
                        flag = true
                      }
                    }
                    !flag && this.person.right.list.push(item)
                  })
                },


                // 事业部弹窗
                  businessShow() {
                    const select = this.$refs.table.$refs.table.selection
                    if (select.length === 1) {
                      this.current = select[0]
                      adminHelp.showDialog(this.business)
                      this.loadBusinessLeft()
                      this.loadBusinessRight()
                    } else {
                         this.$help.error('请先选择有效记录，再执行该操作。')
                    }
                  },

                businessSave() {
                  let arr = []
                  this.business.right.list.forEach(item => {
                    arr.push(item.busiCode)
                  })
                     this.$api.post('sys/powerData/insertRolePowerData', {
                      roleId: this.current.id,
                      objectIdList: arr,
                      powerObject: 4
                  })
                   .then(res => {
                         this.$help.success(res.msg)
                         this.business.show = false
                       })
                   .catch(error => {
                         this.$help.error(error.error || error.obj)
                     })
                   .finally(() => {
                         this.business.show = false
                   })
                },

                 loadBusinessLeft() {
                  this.business.left.loading = true
                  this.business.left.query.model.checkStatus = 1
                  this.$api.post('base/business/findBusinessPage',this.business.left.query)
                    .then(res => {
                      this.business.left.list = res.records
                      this.business.left.query.total = res.total
                    })
                    .finally(() => {
                      this.business.left.loading = false
                    })
                },
                loadBusinessRight() {
                this.$api.post('base/business/selectBusinessByRoleId',{roleId:this.current.id})
                    .then(res => {
                      this.business.right.list = res
                    })
                },

                 handleLeftSizeChangeBusiness(val) {
                    this.business.left.query.size = val
                    this.business.left.query.current = 1
                    this.loadBusinessLeft()
                  },
                  handleLeftCurrentBusiness(val) {
                    if (typeof val === 'number') {
                      this.business.left.query.current = val
                      this.loadBusinessLeft()

                    }
                  },
                  transferBusiness() {
                      this.$refs.leftTable.$refs.datatable.selection.forEach(item => {
                        let flag = false
                        for (let i = 0; i < this.business.right.list.length; i += 1) {
                          if (item.id === this.business.right.list[i].id) {
                            flag = true
                          }
                        }
                        !flag && this.business.right.list.push(item)
                      })
                    },

                removeObj(index,obj) {
                  obj.right.list.splice(index, 1)
                },

            authorize() {
                let select = this.$refs.table.$refs.table.selection
                if (select.length === 1) {
                    adminHelp.showDialog(this.tree, {
                        item: select[0]
                    })
                    // 加载权限列表
                    this.tree.loading = true
                    this.$api.post('sys/role/selectRoleMenu', {id:select[0].id})
                        .then(res => {
                            this.tree.rightList = res

                            // 设置选中的权限
                            let checked = []
                            res.forEach(parent => {
                                parent.children.forEach(child => {
                                    if (child.children && child.children.length > 0) {
                                        child.children.forEach(item => {
                                            if (item.isCheck) {
                                                checked.push(item.id)
                                            }
                                        })
                                    } else {
                                        if (child.isCheck) {
                                            checked.push(child.id)
                                        }
                                    }
                                })
                            })
                            this.tree.defaultCheckedKeys = checked
                        })
                        .finally(() => {
                            this.tree.loading = false
                        })
                } else {
                    this.$help.error('请先选择有效记录，再执行该操作。')
                }
            },
            authorizeSave() {
                this.$help.loading();
                const tree = this.$refs.tree
                this.$api.post('sys/powerMenu/insertRoleMenus', {
                    menuIdList: tree.getCheckedKeys().concat(tree.getHalfCheckedKeys()),
                    roleId: this.tree.item.id
                })
                 .then(res => {
                       this.$help.success(res.msg)
                       this.tree.show = false
                     })
                 .catch(error => {
                       this.$help.error(error.error || error.obj)
                   })
                 .finally(() => {
                       this.$help.loaded();
                       this.tree.loading = false
                 })
            },
            openOrClose(flag = false) {
                for (let i = 0; i < this.$refs.tree.store._getAllNodes().length; i++) {
                    this.$refs.tree.store._getAllNodes()[i].expanded = flag
                }
            }
        },
        created() {
            // 枚举类型查询
            let dataCode = [];
            for (let i = 0; i < this.cols.length; i++) {
                if (this.cols[i].param && this.cols[i].param.dict) {
                    dataCode.push(this.cols[i].param.dict);
                }
            }
            if (dataCode.length !== 0) {
                this.$api.post('sys/dict/selectDictItemMap', dataCode)
                    .then(res => {
                        for (let i = 0; i < this.cols.length; i++) {
                            if (this.cols[i].param && this.cols[i].param.dict) {
                                let keyValue = {};
                                if(res[this.cols[i].param.dict]){
                                    for (let j = 0; j< res[this.cols[i].param.dict].length; j++){
                                        keyValue[res[this.cols[i].param.dict][j].itemDataCode] = res[this.cols[i].param.dict][j].itemDataName;
                                    }
                                    this.cols[i].param.keyValue = keyValue;
                                }
                            }
                        }
                        this.loaded = false;
                        this.$nextTick(() => {this.loaded = true});
                    });
            }
            //按钮权限查询

        },
    }
</script>
